import { RouterProvider } from "react-router-dom";
import router from "../navigation/router";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";
import "./App.css";
import { EventsProxyProvider } from "../utils/context/eventsProxy/context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <EventsProxyProvider>
          <RouterProvider router={router} />
        </EventsProxyProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
